










import converter from "json-2-csv";
import providers from "@/lib/providers";
import { InputUsersSearch, UsersSearchResult } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { defineComponent } from "@vue/composition-api";
import { getAllPageableData } from "@/lib/requestHelper";
import { $t } from "@/lib/helpers/i18nHelper";

export default defineComponent({
  name: "UserListExport",
  props: {
    searchRequestData: { type: Object as () => InputUsersSearch },
  },
  data() {
    return {
      usersSearchResult: {} as UsersSearchResult,
      loading: false,
      csv: "",
    };
  },
  methods: {
    async onDownload() {
      try {
        this.loading = true;
        this.usersSearchResult = await getAllPageableData(page =>
          providers.UserProvider.search({ data: { ...(this.searchRequestData ?? {}), page } })
        );

        if (!this.usersSearchResult?.result) {
          return;
        }

        this.csv = await converter.json2csvAsync(this.usersSearchResult?.result, {
          keys: [
            { field: "username", title: $t("User name") },
            { field: "screenName", title: $t("Screen name") },
            { field: "email", title: $t("Email address") },
            { field: "phone", title: $t("Phone number") },
            { field: "accountInfo.registrationIp", title: $t("Sign up IP") },
            { field: "accountInfo.lastLoginIp", title: $t("Last login IP") },
          ],
          emptyFieldValue: "",
          expandArrayObjects: true,
          delimiter: {
            wrap: "''", // Double Quote (") character
            field: ",", // Comma field delimiter
            eol: "\n", // Newline delimiter
          },
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    fileUrl(): string {
      return this.csv ? window.URL.createObjectURL(new Blob([this.csv])) : "";
    },
  },
  watch: {
    searchRequestData() {
      this.csv = "";
    },
  },
});
